export default __webpack_public_path__ + "atomic/_patterns/01-atoms/view-style-list-item/_view-style-list-item.twig";